import { cn } from "../../lib/utils";

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "animate-gradient-bg from-widget-skeleton-grad-left via-widget-skeleton-grad-right to-widget-skeleton-grad-left rounded-md bg-gradient-to-l bg-[length:200%_200%] bg-[position:0%_50%]",
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
